<template>
  <section>
    <!-- Header -->
    <left-menu />

    <button-back :btnRoute="'/detalhe-do-ponto/' + $route.params.idPoint + '/' + + $route.params.type"/>

    <div id="mainContent" class="adjustment-content">
      <loading-page v-if="loading" />

      <div v-else class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 pg-title">
          <h1 class="certa">Solicitar Ajuste/Abono</h1>
          <p>{{objValue.date | strDayFull}}, {{objValue.date | dateDay}} de {{objValue.date | strMonthFull}} de {{objValue.date | yearNumber}}</p>
        </div>

        <div class="col-xs-12 col-sm-12 col-md-12 type-adjustment offset-top-30">
          <p class="nunito">Tipo de solicitação:</p>
          <select v-model="typeSelected">
            <option value="">Selecione</option>
            <option value="1">Ajuste</option>
            <option value="2">Abono</option>
          </select>
        </div>

        <div class="col-xs-12 col-sm-12 col-md-12 offset-top-30">
          <div v-if="typeSelected === '1'" class="col-xs-12 col-sm-12 col-md-12 default-box box-adjustment">
            <div v-if="objValue.userPointJson" class="row">
              <div class="col-xs-12 col-sm-12 col-md-12">
                <p>Histórico de ponto do dia</p>
                <ul v-if="objValue.userPointJson" class="timeline-point offset-top-20">
                  <li v-for="dt in objValue.userPointJsonConvert">
                    <div class="username">
                      <p v-bind:title="'Ponto registrado as: ' + dt.Hour">{{dt.Hour}}</p>
                    </div>
                    <div class="timestamp">
                      <p>{{dt.hour}}</p>
                    </div>
                    <div class="status">
                      <p></p>
                    </div>
                  </li>
                </ul>
                <!--<div ng-show="!dataTimelineUserPoint.list.length" ng-style="{'min-height': '100px'}" class="content-empty">-->
                <!--<p class="empty">Nenhum registro de ponto hoje.</p>-->
                <!--</div>-->
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-12 col-md-12">
                <p>Altere os horários necessários:</p>
              </div>
              <div v-for="(h, index) in listHours" class="col-xs-12 col-sm-6 col-md-4">
                <div class="col-xs-12 col-sm-12 col-md-12 box-hours">
                  <!-- Data entrada -->
                  <div class="row">
                    <div class="col-xs-12 col-sm-12 col-md-12">
                      <h4 class="certa">Entrada {{index +1}}</h4>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6">
                      <div class="form-group">
                        <label class="nunito">Data</label>
                        <input v-model="h.entry" v-mask="'##/##/####'" placeholder="00/00/0000" type="text" class="form-control">
                        <span v-if="h.isDateEntry && $v.listHours.$each[index].entry.$error" class="required-field">Por favor preencha uma data válida.</span>
                        <span v-if="!h.isDateEntry" class="required-field">Por favor preencha uma data válida.</span>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6">
                      <div class="form-group">
                        <label class="nunito">Hora</label>
                        <input v-model="h.hourEntry" v-mask="'##:##'" maxlength="5" placeholder="00:00" type="text" class="form-control">
                        <span v-if="h.isValidEntry && $v.listHours.$each[index].hourEntry.$error" class="required-field">Por favor preencha um horário válido.</span>
                        <span v-if="!h.isValidEntry" class="required-field">Por favor preencha um horário válido.</span>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-12 line"></div>
                  </div>

                  <!-- Data saída -->
                  <div class="row">
                    <div class="col-xs-12 col-sm-12 col-md-12">
                      <h4 class="certa">Saída {{index +1}}</h4>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6">
                      <div class="form-group">
                        <label class="nunito">Data</label>
                        <input v-model="h.exit" v-mask="'##/##/####'" placeholder="00/00/0000" type="text" class="form-control">
                        <span v-if="h.isDateExit && $v.listHours.$each[index].exit.$error" class="required-field">Por favor preencha uma data válida.</span>
                        <span v-if="!h.isDateExit" class="required-field">Por favor preencha uma data válida.</span>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6">
                      <div class="form-group">
                        <label class="nunito">Horário</label>
                        <input v-model="h.hourExit" v-mask="'##:##'" maxlength="5" placeholder="00:00" type="text" class="form-control">
                        <span v-if="h.isValidExit && $v.listHours.$each[index].hourExit.$error" class="required-field">Por favor preencha um horário válido.</span>
                        <span v-if="!h.isValidExit" class="required-field">Por favor preencha um horário válido.</span>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-12 line"></div>
                  </div>

                  <!-- Remove Data -->
                  <div class="row">
                    <div class="col-xs-12 col-sm-12 col-md-12 remove">
                      <p v-on:click="removeHour(index)" class="certa"> <i class="fa fa-trash"></i> Excluir Período</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-4">
                <div v-on:click="addHour()" class="add-period">
                  <p>
                    <span>+</span>
                    Adicionar novo período
                  </p>
                </div>
              </div>
            </div>
            <div class="row">
              <div v-bind:class="{'col-md-4': motiveAdjustment.name.toLowerCase() === 'outro', 'col-md-6': motiveAdjustment.name.toLowerCase() !== 'outro'}" class="col-xs-12 col-sm-12 offset-top-10">
                <p class="nunito">Selecione o motivo do ajuste:</p>
                <select v-model="motiveAdjustment">
                  <option v-for="a in listAdj" v-bind:value="a">{{a.name}}</option>
                </select>
                <span v-if="!invalidMotive && $v.motiveAdjustment.$error" class="required-field">Selecione o motivo da solicitação.</span>
                <span v-if="invalidMotive && motiveAdjustment.name.toLowerCase() === 'selecione'" class="required-field">Selecione o motivo da solicitação.</span>
              </div>
              <div v-if="motiveAdjustment.name.toLowerCase() === 'outro' || motiveAdjustment.name.toLowerCase() === 'outros'" class="col-xs-12 col-sm-12 col-md-4 offset-top-10">
                <p class="nunito">Observação</p>
                <input v-model="dataSend.reason" class="form-control input-info" placeholder="Motivo da solicitação" name="obs" required />
                <span v-if="(motiveAdjustment.name.toLowerCase() === 'outro' || motiveAdjustment.name.toLowerCase() === 'outros') && !dataSend.reason" class="required-field">Preencha uma observação.</span>
              </div>
              <div v-bind:class="{'col-md-4': motiveAdjustment.name.toLowerCase() === 'outro', 'col-md-6': motiveAdjustment.name.toLowerCase() !== 'outro'}" class="col-xs-12 col-sm-12 offset-top-10">
                <div class="input-group">
                  <p class="nunito">Anexar atestado ou documento <span>(opcional)</span>:</p>
                  <input type="file" id="documentFile1" ref="myFiles" class="custom-file-input" @change="previewFiles" style="display: none">
                  <input @click="attachFile('#documentFile1')" v-model="fileName" class="form-control" placeholder="Atestado (JPG ou PDF)" type="text" name="document">
                  <img v-if="uploadStage === 'success'" src="../../../../assets/img/conf_send.png" class="status-file" height="22" width="22">
                  <img v-if="uploadStage === 'fail'" src="../../../../assets/img/fail_send.png" class="status-file" height="22" width="22">
                  <div v-if="uploadStage === 'loading'" class="loading-file">
                    <span><i class="glyphicon glyphicon-repeat spinning"></i></span>
                  </div>
                  <span class="input-group-btn">
                        <button v-on:click="attachFile('#documentFile1')" type="button" class="certa">Selecionar</button>
                      </span>
                </div>
              </div>


              <div v-if="needException" class="col-xs-12 col-sm-12 col-md-12 padding-null">
                <div class="col-xs-12 col-sm-12 col-md-6 offset-top-10">
                  <p class="nunito">Motivo do ponto por exceção:</p>
                  <select v-model="motiveException">
                    <option value="">Selecione</option>
                    <option v-for="a in listException" v-bind:value="a">{{a.name}}</option>
                  </select>
                  <span v-if="validateException" class="required-field">Selecione o motivo da exceção.</span>
                </div>
              </div>


              <div class="col-xs-12 col-sm-12 col-md-12 offset-top-30">
                <button @click="checkAdjustment()"  type="submit" class="certa">
                  <div v-if="loadingSend" class="loading-btn">
                    <div class="spinner-btn">
                      <div class="rect1"></div>
                      <div class="rect2"></div>
                      <div class="rect3"></div>
                      <div class="rect4"></div>
                      <div class="rect5"></div>
                    </div>
                  </div>
                  <span v-else>
                    <svg width="24" height="24" viewBox="0 0 24 24">
                      <path class="a" d="M2.01,21,23,12,2.01,3,2,10l15,2L2,14Z"/>
                    </svg>
                      <span>Enviar Solicitação</span></span>
                </button>
              </div>
            </div>
          </div>

          <div v-if="typeSelected === '2'" class="col-xs-12 col-sm-12 col-md-12 default-box box-adjustment">
            <div v-if="objValue.userPointJson" class="row">
              <div class="col-xs-12 col-sm-12 col-md-12">
                <p>Histórico de ponto do dia</p>
                <ul v-if="objValue.userPointJson" class="timeline-point offset-top-20">
                  <li v-for="dt in objValue.userPointJsonConvert">
                    <div class="username">
                      <p v-bind:title="'Ponto registrado as: ' + dt.Hour">{{dt.Hour}}</p>
                    </div>
                    <div class="timestamp">
                      <p>{{dt.hour}}</p>
                    </div>
                    <div class="status">
                      <p></p>
                    </div>
                  </li>
                </ul>
                <!--<div ng-show="!dataTimelineUserPoint.list.length" ng-style="{'min-height': '100px'}" class="content-empty">-->
                <!--<p class="empty">Nenhum registro de ponto hoje.</p>-->
                <!--</div>-->
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-12 col-md-12">
                <div class="col-xs-12 col-sm-6 col-md-6 offset-top-10">
                  <p class="nunito">Tipo de abono:</p>
                  <select v-model="isAbonoAllDay">
                    <option value="">Selecione</option>
                    <option value="false">Período</option>
                    <option value="true">Dia inteiro</option>
                  </select>
                  <!--                    <span v-if="$v.isAbonoAllDay.$error" class="required-field">Selecione o tipo de abono.</span>-->
                </div>
                <div class="col-xs-12 col-sm-6 col-md-6 offset-top-10">
                  <div class="input-group">
                    <p class="nunito">Atestado ou Documento</p>
                    <input type="file" id="documentFile" ref="myFiles" class="custom-file-input" @change="previewFiles" style="display: none">
                    <input @click="attachFile('#documentFile')" v-model="fileName" class="form-control" placeholder="Atestado (JPG ou PDF)" type="text" name="document">
                    <img v-if="uploadStage === 'success'" src="../../../../assets/img/conf_send.png" class="status-file" height="22" width="22">
                    <img v-if="uploadStage === 'fail'" src="../../../../assets/img/fail_send.png" class="status-file" height="22" width="22">
                    <div v-if="uploadStage === 'loading'" class="loading-file">
                      <span><i class="glyphicon glyphicon-repeat spinning"></i></span>
                    </div>
                    <span class="input-group-btn">
                        <button v-on:click="attachFile('#documentFile')" type="button">Selecionar</button>
                      </span>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-6 offset-top-20">
                  <p class="nunito">Motivo da solicitação</p>
                  <select v-model="motiveAllowance">
                    <option v-for="a in orderBy(listAdjAbono, 'name')" v-bind:value="a">
                      {{ a.name }}
                    </option>
                  </select>
                  <span v-if="!invalidMotive && $v.motiveAllowance.$error" class="required-field">Selecione o motivo da solicitação.</span>
                  <span v-if="invalidMotive && motiveAllowance.name.toLowerCase() === 'selecione'" class="required-field">Selecione o motivo da solicitação.</span>
                </div>
                <div v-if="motiveAllowance.name.toLowerCase() === 'outro'" class="col-xs-12 col-sm-6 col-md-6 offset-top-20">
                  <p class="nunito">Observação</p>
                  <input v-model="dataSend.reason" class="form-control input-info" placeholder="Motivo da solicitação" name="obs" required />
                  <span v-if="(motiveAllowance.name.toLowerCase().trim() === 'outro' || motiveAllowance.name.toLowerCase().trim() === 'outros') && !dataSend.reason" class="required-field">Preencha uma observação.</span>
                </div>
                <div v-if="needException" class="col-xs-12 col-sm-12 col-md-6 offset-top-20">
                  <p class="nunito">Motivo do ponto por exceção:</p>
                  <select v-model="motiveExceptionAbono">
                    <option value="">Selecione</option>
                    <option v-for="a in listException" v-bind:value="a">{{a.name}}</option>
                  </select>
                  <span v-if="validateExceptionAbono" class="required-field">Selecione o motivo da exceção.</span>
                </div>

                <div class="col-xs-12 col-sm-12 col-md-12 offset-top-20">
                  <div class="checkbox">
                    <input id="check1" type="checkbox" v-model="payMissingHours">
                    <label for="check1"><span>Abonar horas faltantes</span></label>
                  </div>
                </div>

                <div v-if="isAbonoAllDay === 'false' && !payMissingHours" class="col-xs-12 col-sm-12 col-md-12 offset-top-30">
                  <div v-for="(h, index) in listHoursAbonoHalfDay" class="col-xs-12 col-sm-7 col-md-4 padding-null">
                    <div class="col-xs-12 col-sm-12 col-md-12 box-hours">
                      <!-- Data entrada -->
                      <div class="row">
                        <div class="col-xs-12 col-sm-12 col-md-12">
                          <h4 class="certa">Entrada {{index +1}}</h4>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-6">
                          <div class="form-group">
                            <label class="ng-binding">Data</label>
                            <input v-model="h.entry" v-mask="'##/##/####'" placeholder="00/00/0000" type="text" class="form-control">
                            <span v-if="h.isDateEntry && $v.listHoursAbonoHalfDay.$each[index].entry.$error" class="required-field">Por favor preencha uma data válida.</span>
                            <span v-if="!h.isDateEntry" class="required-field">Por favor preencha uma data válida.</span>
                          </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-6">
                          <div class="form-group">
                            <label class="ng-binding">Hora</label>
                            <input v-model="h.hourEntry" v-mask="'##:##'" maxlength="5" placeholder="00:00" type="text" class="form-control">
                            <span v-if="h.isValidEntry && $v.listHoursAbonoHalfDay.$each[index].hourEntry.$error" class="required-field">Por favor preencha um horário válido.</span>
                            <span v-if="!h.isValidEntry" class="required-field">Por favor preencha um horário válido.</span>
                          </div>
                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-12 line"></div>
                      </div>

                      <!-- Data saída -->
                      <div class="row">
                        <div class="col-xs-12 col-sm-12 col-md-12">
                          <h4 class="certa">Saída {{index +1}}</h4>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-6">
                          <div class="form-group">
                            <label class="ng-binding">Data</label>
                            <input v-model="h.exit" v-mask="'##/##/####'" placeholder="00/00/0000" type="text" class="form-control">
                            <span v-if="h.isDateExit && $v.listHoursAbonoHalfDay.$each[index].exit.$error" class="required-field">Por favor preencha uma data válida.</span>
                            <span v-if="!h.isDateExit" class="required-field">Por favor preencha uma data válida.</span>
                          </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-6">
                          <div class="form-group">
                            <label class="ng-binding">Hora</label>
                            <input v-model="h.hourExit" v-mask="'##:##'" maxlength="5" placeholder="00:00" type="text" class="form-control">
                            <span v-if="h.isValidExit && $v.listHoursAbonoHalfDay.$each[index].hourExit.$error" class="required-field">Por favor preencha um horário válido.</span>
                            <span v-if="!h.isValidExit" class="required-field">Por favor preencha um horário válido.</span>
                          </div>
                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-12 offset-top-20"></div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-xs-12 col-sm-12 col-md-12 offset-top-30">
                  <button @click="checkAbono()" type="button">
                    <div v-if="loadingSend" class="loading-btn">
                      <div class="spinner-btn">
                        <div class="rect1"></div>
                        <div class="rect2"></div>
                        <div class="rect3"></div>
                        <div class="rect4"></div>
                        <div class="rect5"></div>
                      </div>
                    </div>
                    <span v-else>
                        <svg width="24" height="24" viewBox="0 0 24 24">
                      <path class="a" d="M2.01,21,23,12,2.01,3,2,10l15,2L2,14Z"/>
                    </svg>
                      <span>Enviar Solicitação</span></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <vue-footer/>
  </section>
</template>

<script>
  import leftMenu from '../../components/leftMenu.vue';
  import buttonBack from "../../components/buttonBack";
  import loadingPage from "../../components/loadingPage";
  import Vue2Filters from 'vue2-filters'

  import moment from 'moment'
  import swal from 'sweetalert';
  import { helpers, required, email, minLength } from 'vuelidate/lib/validators';

  import {
    POINT_DAY,
    UPLOAD_IMG,
    ADJUSTMENT,
    CAN_MAKE_SOLICITATION,
    GET_COMPANY_ADJ,
    GET_EXCEPTION
  } from "../../../../urlConfig";
  import { REQUEST_SERVICE } from "../../../../requestConfig";
  import { UTIL_SERVICE } from "../../../../utils";
  import vueFooter from "../../components/footer.vue";

  export default {
    name: "request-adjustment",
    components: {
      vueFooter,
      leftMenu,
      loadingPage,
      buttonBack
    },
    mixins: [Vue2Filters.mixin],
    data() {
      return {
        listAdj: [],
        listAdjAbono: [],
        listException: [],
        needException: false,
        invalidMotive: false,
        historyListPoints: null,
        storageHomeCtrl: null,
        myOccurrenceCtrl: null,
        pointHistoryCtrl: null,
        motiveAdjustment: {
          name: 'Selecione',
          id: ''
        },
        motiveAllowance: {
          name: 'Selecione',
          id: ''
        },
        motiveException : '',
        motiveExceptionAbono : '',
        lastDateFormated: "",
        dataSend: {
          reason: "",
          imageUri: "",
          userPointAdjustmentStatus: "",
          userPointAdjustmentType: 0,
          userPointDayId: this.$route.params.idPoint,
          listDates: [],
          deviceId: '',
          deviceType: ''
        },
        objValue: "",
        uploadStage: "",
        files: [],
        fileName: "",
        loading: false,
        loadingSend: false,
        validateException: false,
        validateExceptionAbono: false,
        isAbonoAllDay: "",
        typeSelected: "",
        listHours: [{entry: '', hourEntry: '', exit: '', hourExit: '', isValidEntry: true, isValidExit: true, isDateEntry: true, isDateExit: true}, { entry: '', hourEntry: '', exit: '', hourExit: '', isValidEntry: true, isValidExit: true, isDateEntry: true, isDateExit: true}],
        listHoursAbonoHalfDay: [{entry: '', hourEntry: '', exit: '', hourExit: '', isValidEntry: true, isValidExit: true, isDateEntry: true, isDateExit: true}],
        payMissingHours: false,
      }
    },
    methods: {
      previewFiles() {
        this.files = this.$refs.myFiles.files;
        if (this.files.length) {
          if (this.files[0].size <= 2097152) {
            this.uploadDocument(this.files[0])
          } else {
            swal("Aviso", "Não foi possivel realizar o envio da imagem.\n\n Motivo: arquivo muito grande por favor enviar um arquivo menor que 2MB.", "warning");
          }
        }
      },
      attachFile(id) {
        $(id).click();
      },
      removeHour(index){
        this.listHours.splice(index, 1);
      },
      addHour() {
        if (this.listHours.length <= 8) {
          if (!this.lastDateFormated) {
            this.listHours.push({entry: this.objValue.convertDate, hourEntry: '', exit: this.objValue.convertDate, hourExit: '', isValidEntry: true, isValidExit: true, isDateEntry: true, isDateExit: true});
          } else {
            this.listHours.push({entry: this.lastDateFormated, hourEntry: '', exit: this.lastDateFormated, hourExit: '', isValidEntry: true, isValidExit: true, isDateEntry: true, isDateExit: true});
          }
        } else {
          swal("Aviso", "Não é possível adicionar mais período.", "error");
        }
      },
      makeSolicitation() {
        this.loading = true;
        REQUEST_SERVICE.get(CAN_MAKE_SOLICITATION + "?id=" + this.$route.params.idPoint).then((response) => {
          UTIL_SERVICE.console("RESULT CAN_MAKE_SOLICITATION:", response.data);

          if (response.data.canRequest) {
            this.getDetail();
          } else {
            swal({
              text: response.data.text,
              title: 'Atenção',
              closeOnClickOutside: false,
              button: {
                text: "Confirmar",
                closeModal: false,
              },
            }).then(pass => {
              if (!pass) throw null;

              swal.stopLoading();
              swal.close();

              this.$router.push({path: '/detalhe-do-ponto/' + this.$route.params.idPoint + '/3'});
            }).catch(err => {
              swal.stopLoading();
              swal.close();
            });
          }
        }).catch(reason => {
          this.loading = false;
          // Show errors.
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
      },
      getDetail() {
        this.loading = true;

        REQUEST_SERVICE.get(POINT_DAY + this.$route.params.idPoint).then((response) => {
          UTIL_SERVICE.console("RESULT POINT_DAY:", response.data);
          response.data.strDay = moment(response.data.date).format("dddd");
          response.data.convertDate = moment(response.data.date).format("DD/MM/YYYY");

          this.listHoursAbonoHalfDay[0].entry = moment(response.data.date).format('DD/MM/YYYY');
          this.listHoursAbonoHalfDay[0].exit = moment(response.data.date).format('DD/MM/YYYY');

          // Convert Json to points
          if (response.data.userPointJson) {
            response.data.userPointJsonConvert = JSON.parse(response.data.userPointJson);
            response.data.userPointJsonConvert = response.data.userPointJsonConvert.slice().reverse();
          }

          // Add list from points case exist
          if (typeof response.data.userPointJsonConvert !== "undefined") {
            if (response.data.userPointJsonConvert.length >= 5)
              this.listHours.push({entry: '', hourEntry: '', exit: '', hourExit: '', isValidEntry: true, isValidExit: true, isDateEntry: true, isDateExit: true});

            if (response.data.userPointJsonConvert.length >= 7)
              this.listHours.push({entry: '', hourEntry: '', exit: '', hourExit: '', isValidEntry: true, isValidExit: true, isDateEntry: true, isDateExit: true});

            if (response.data.userPointJsonConvert.length >= 9)
              this.listHours.push({entry: '', hourEntry: '', exit: '', hourExit: '', isValidEntry: true, isValidExit: true, isDateEntry: true, isDateExit: true});

            if (response.data.userPointJsonConvert.length >= 11)
              this.listHours.push({entry: '', hourEntry: '', exit: '', hourExit: '', isValidEntry: true, isValidExit: true, isDateEntry: true, isDateExit: true});

            if (response.data.userPointJsonConvert.length >= 13)
              this.listHours.push({entry: '', hourEntry: '', exit: '', hourExit: '', isValidEntry: true, isValidExit: true, isDateEntry: true, isDateExit: true});

            response.data.userPointJsonConvert.map((value, index) => {
              if (value.Date)
                this.lastDateFormated = moment(value.Date).format('DD/MM/YYYY');

              if (value.date)
                this.lastDateFormated = moment(value.date).format('DD/MM/YYYY');

              if (value.date) {
                if (!this.listHours[0].hourEntry) {
                  this.listHours[0].entry = moment(value.date).format('DD/MM/YYYY');
                  this.listHoursAbonoHalfDay[0].entry = moment(value.date).format('DD/MM/YYYY');
                  this.listHours[0].hourEntry = value.hour.substring(0, 5);
                } else if (!this.listHours[0].hourExit) {
                  this.listHours[0].exit = moment(value.date).format('DD/MM/YYYY');
                  this.listHoursAbonoHalfDay[0].exit = moment(value.date).format('DD/MM/YYYY');
                  this.listHours[0].hourExit = value.hour.substring(0, 5);
                } else if (!this.listHours[1].hourEntry) {
                  this.listHours[1].entry = moment(value.date).format('DD/MM/YYYY');
                  this.listHours[1].hourEntry = value.hour.substring(0, 5);
                } else if (!this.listHours[1].hourExit) {
                  this.listHours[1].exit = moment(value.date).format('DD/MM/YYYY');
                  this.listHours[1].hourExit = value.hour.substring(0, 5);
                } else if (!this.listHours[2].hourEntry) {
                  this.listHours[2].entry = moment(value.date).format('DD/MM/YYYY');
                  this.listHours[2].hourEntry = value.hour.substring(0, 5);
                } else if (!this.listHours[2].hourExit) {
                  this.listHours[2].exit = moment(value.date).format('DD/MM/YYYY');
                  this.listHours[2].hourExit = value.hour.substring(0, 5);
                } else if (!this.listHours[3].hourEntry) {
                  this.listHours[3].entry = moment(value.date).format('DD/MM/YYYY');
                  this.listHours[3].hourEntry = value.hour.substring(0, 5);
                } else if (!this.listHours[3].hourExit) {
                  this.listHours[3].exit = moment(value.date).format('DD/MM/YYYY');
                  this.listHours[3].hourExit = value.hour.substring(0, 5);
                } else if (!this.listHours[4].hourEntry) {
                  this.listHours[4].entry = moment(value.date).format('DD/MM/YYYY');
                  this.listHours[4].hourEntry = value.hour.substring(0, 5);
                } else if (!this.listHours[4].hourExit) {
                  this.listHours[4].exit = moment(value.date).format('DD/MM/YYYY');
                  this.listHours[4].hourExit = value.hour.substring(0, 5);
                }  else if (!this.listHours[5].hourEntry) {
                  this.listHours[5].entry = moment(value.date).format('DD/MM/YYYY');
                  this.listHours[5].hourEntry = value.hour.substring(0, 5);
                } else if (!this.listHours[5].hourExit) {
                  this.listHours[5].exit = moment(value.date).format('DD/MM/YYYY');
                  this.listHours[5].hourExit = value.hour.substring(0, 5);
                }  else if (!this.listHours[6].hourEntry) {
                  this.listHours[6].entry = moment(value.date).format('DD/MM/YYYY');
                  this.listHours[6].hourEntry = value.hour.substring(0, 5);
                } else if (!this.listHours[6].hourExit) {
                  this.listHours[6].exit = moment(value.date).format('DD/MM/YYYY');
                  this.listHours[6].hourExit = value.hour.substring(0, 5);
                }
              } else {
                if (!this.listHours[0].hourEntry) {
                  this.listHours[0].entry = moment(value.Date).format('DD/MM/YYYY');
                  this.listHoursAbonoHalfDay[0].entry = moment(value.Date).format('DD/MM/YYYY');
                  this.listHours[0].hourEntry = value.Hour.substring(0, 5);

                  if (!this.listHours[0].hourExit) {
                    this.listHoursAbonoHalfDay[0].exit = moment(value.Date).format('DD/MM/YYYY');
                  }
                } else if (!this.listHours[0].hourExit) {
                  this.listHours[0].exit = moment(value.Date).format('DD/MM/YYYY');
                  this.listHoursAbonoHalfDay[0].exit = moment(value.Date).format('DD/MM/YYYY');
                  this.listHours[0].hourExit = value.Hour.substring(0, 5);
                } else if (!this.listHours[1].hourEntry) {
                  this.listHours[1].entry = moment(value.Date).format('DD/MM/YYYY');
                  this.listHours[1].hourEntry = value.Hour.substring(0, 5);
                } else if (!this.listHours[1].hourExit) {
                  this.listHours[1].exit = moment(value.Date).format('DD/MM/YYYY');
                  this.listHours[1].hourExit = value.Hour.substring(0, 5);
                } else if (!this.listHours[2].hourEntry) {
                  this.listHours[2].entry = moment(value.Date).format('DD/MM/YYYY');
                  this.listHours[2].hourEntry = value.Hour.substring(0, 5);
                } else if (!this.listHours[2].hourExit) {
                  this.listHours[2].exit = moment(value.Date).format('DD/MM/YYYY');
                  this.listHours[2].hourExit = value.Hour.substring(0, 5);
                } else if (!this.listHours[3].hourEntry) {
                  this.listHours[3].entry = moment(value.Date).format('DD/MM/YYYY');
                  this.listHours[3].hourEntry = value.Hour.substring(0, 5);
                } else if (!this.listHours[3].hourExit) {
                  this.listHours[3].exit = moment(value.Date).format('DD/MM/YYYY');
                  this.listHours[3].hourExit = value.Hour.substring(0, 5);
                } else if (!this.listHours[4].hourEntry) {
                  this.listHours[4].entry = moment(value.Date).format('DD/MM/YYYY');
                  this.listHours[4].hourEntry = value.Hour.substring(0, 5);
                } else if (!this.listHours[4].hourExit) {
                  this.listHours[4].exit = moment(value.Date).format('DD/MM/YYYY');
                  this.listHours[4].hourExit = value.Hour.substring(0, 5);
                }  else if (!this.listHours[5].hourEntry) {
                  this.listHours[5].entry = moment(value.Date).format('DD/MM/YYYY');
                  this.listHours[5].hourEntry = value.Hour.substring(0, 5);
                } else if (!this.listHours[5].hourExit) {
                  this.listHours[5].exit = moment(value.Date).format('DD/MM/YYYY');
                  this.listHours[5].hourExit = value.Hour.substring(0, 5);
                }  else if (!this.listHours[6].hourEntry) {
                  this.listHours[6].entry = moment(value.Date).format('DD/MM/YYYY');
                  this.listHours[6].hourEntry = value.Hour.substring(0, 5);
                } else if (!this.listHours[6].hourExit) {
                  this.listHours[6].exit = moment(value.Date).format('DD/MM/YYYY');
                  this.listHours[6].hourExit = value.Hour.substring(0, 5);
                }
              }
            });
          }

          setTimeout(() => {
            if (!this.listHours[0].entry)
              this.listHours[0].entry = this.objValue.convertDate;

            if (!this.listHours[0].exit)
              this.listHours[0].exit = this.listHours[0].entry;

            if (!this.listHours[1].entry)
              this.listHours[1].entry =  this.listHours[0].exit;

            if (!this.listHours[1].exit)
              this.listHours[1].exit = this.listHours[1].entry;
          }, 300);

          this.objValue = response.data;

          // Saves values to variables
          this.storageHomeCtrl = UTIL_SERVICE.getStorage('homeCtrl');
          this.myOccurrenceCtrl = UTIL_SERVICE.getStorage('myOccurrenceCtrl');
          this.pointHistoryCtrl = UTIL_SERVICE.getStorage('pointHistoryCtrl');

          // Change value 'userPointAdjustmentStatus' to pending adjustment
          if (this.storageHomeCtrl) {
            if (this.storageHomeCtrl.listPoint.length) {
              this.storageHomeCtrl.listPoint.map((value, index) => {
                if (value.id === this.$route.params.idPoint) {
                  value.userPointAdjustmentStatus = 1;
                }
              });
            }
          }

          if (this.pointHistoryCtrl) {
            if (this.pointHistoryCtrl.listHistory.length) {
              this.pointHistoryCtrl.listHistory.map((value, index) => {
                if (value.id === this.$route.params.idPoint) {
                  value.userPointAdjustmentStatus = 1;
                }
              });
            }
          }

          this.loading = false;
        }).catch(reason => {
          try {
            UTIL_SERVICE.historyLog(false, window.location.pathname, 'getDetail', {id: this.$route.params.idPoint}, true, reason.response.data);
          } catch (e) {}
          this.loading = false;
          // Show errors.
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
      },
      sendRequest() {
        if (!this.loadingSend) {
          this.historyListPoints = UTIL_SERVICE.getStorage('historyListPoints');
          this.historyListPoints.showNew = true;
          this.historyListPoints.count = 1;

          if (this.historyListPoints.list.length >= 10)
            this.historyListPoints.list.splice(this.historyListPoints.list.length - 1, 1);

          this.loadingSend = true;

          this.dataSend.pointReference = this.objValue.pointReference;
          this.dataSend.deviceId = JSON.parse(window.localStorage.getItem('browserId'));
          this.dataSend.deviceType = "3";

          if(this.payMissingHours) {
            this.dataSend.fillHoursMissing = true;
            this.dataSend.listDates = [];
          }

          UTIL_SERVICE.console("DATA SEND:" , this.dataSend);
          REQUEST_SERVICE.post(ADJUSTMENT, this.dataSend).then((response) => {
            UTIL_SERVICE.console("RESULT ADJUSTMENT DOCUMENT: ", response);

            // Save value 'userPointAdjustmentStatus = 1' to pending adjustment
            // if (this.storageHomeCtrl)
            //   UTIL_SERVICE.saveStorage('homeCtrl', this.storageHomeCtrl);

            if (this.myOccurrenceCtrl)
              UTIL_SERVICE.saveStorage('myOccurrenceCtrl', this.myOccurrenceCtrl);

            if (this.pointHistoryCtrl)
              UTIL_SERVICE.saveStorage('pointHistoryCtrl', this.pointHistoryCtrl);

            this.historyListPoints.list.unshift({text: 'Ajuste solicitado para o dia: ', date: this.objValue.date, type: 2});
            UTIL_SERVICE.saveStorage('historyListPoints', this.historyListPoints);

            // Remove Storage from list solicitation
            UTIL_SERVICE.saveStorage('myRequestsCtrl', { dateAtt: null, dataControl: null, data: null });

            swal("Aviso", response.data, "success");
            // Redirect user.
            this.$router.push({path: '/detalhe-do-ponto/' + this.$route.params.idPoint + '/' + this.$route.params.type});
            this.loadingSend = false;

            const homeCtrl = UTIL_SERVICE.getStorage('homeCtrl')
            homeCtrl.homeNeedReload = true;
            homeCtrl.advicesNeedReload = true;
            UTIL_SERVICE.saveStorage('homeCtrl', homeCtrl)

          }).catch(reason => {
            try {
              UTIL_SERVICE.historyLog(false, window.location.pathname, 'sendRequest', this.dataSend, true, reason.response.data);
            } catch (e) {}

            this.loadingSend = false;
            // Show errors.
            reason.response.data.erros.map((value, index) => {
              swal("Aviso", value.value, "error");
            });
          });
        }
      },
      uploadDocument(file) {
        this.uploadStage = "loading";
        this.fileName = file.name;
        REQUEST_SERVICE.fileUpload(UPLOAD_IMG, file).then((response) => {
          UTIL_SERVICE.console("RESULT UPLOAD DOCUMENT: ", response);

          this.dataSend.imageUri = response.data;
          this.uploadStage = "success";

        }).catch(reason => {
          this.uploadStage = "fail";
        });
      },
      checkAdjustment() {
        let isValidForm = true;
        this.invalidMotive = false;
        this.dataSend.listDates = [];
        this.dataSend.userPointAdjustmentType = 1;

        this.$v.dataSend.$touch();
        this.$v.listHours.$touch();

        // Cancel form if you have an error.
        if (this.$v.dataSend.$error) return;

        // Check whether the select contains the value 4 and is empty.
        if (this.motiveAdjustment.name.toLowerCase() === 'selecione') {
          this.invalidMotive = true;
          return;
        }
        if (this.motiveAdjustment.name.toLowerCase() === 'outro' && !this.dataSend.reason) return;

        if (this.motiveAdjustment.name.toLowerCase() !== 'outro') {
          this.dataSend.reason = this.motiveAdjustment.name;
        }

        if(this.needException) {
          if(this.motiveException) {
            this.dataSend.sporadicCategoryId = this.motiveException.id
            this.validateException = false
          } else {
            return this.validateException = true
          }
        }

        this.dataSend.userPointAdjustmentStatus = this.motiveAdjustment.id;

        if (this.listHours.length) {
          this.listHours.map((value, index) => {
            value.isValidEntry = this.checkHoursIsValid(value.hourEntry);
            value.isValidExit = this.checkHoursIsValid(value.hourExit);

            // Check all dates and hours is valid.
            if (!value.isValidExit || !value.isValidEntry || !value.entry || !value.exit)
              isValidForm = false;

            if (UTIL_SERVICE.checkDateStringIsInvalid(value.entry)) {
              isValidForm = false;
              value.isDateEntry = false;
            }

            if (UTIL_SERVICE.checkDateStringIsInvalid(value.exit)) {
              isValidForm = false;
              value.isDateExit = false;
            }

            // Case is valid add to list.
            if (isValidForm) {
              this.dataSend.listDates.push({
                date: moment(UTIL_SERVICE.convertStringToDateEua(value.entry)).format('YYYY-MM-DD') + "T" + value.hourEntry + ":00",
                userPointType: 1
              });
              this.dataSend.listDates.push({
                date: moment(UTIL_SERVICE.convertStringToDateEua(value.exit)).format('YYYY-MM-DD') + "T" + value.hourExit + ":00",
                userPointType: 2
              });
            }

            if (this.listHours.length === index + 1) {
              if (isValidForm) {
                this.sendRequest();
              }
            }
          });
        } else {
          this.sendRequest();
        }
      },
      checkAbono() {
        this.invalidMotive = false;
        this.dataSend.userPointAdjustmentType = 2;
        this.$v.dataSend.$touch();

        // Check sure it's for the whole day.
        if (this.isAbonoAllDay === "false" && !this.payMissingHours) {
          // Touch input from date
          this.$v.listHoursAbonoHalfDay.$touch();
          // Cancel form if you have an error
          if (this.$v.listHoursAbonoHalfDay.$error) return;
        }

        // Cancel form if you have an error.
        if (this.$v.dataSend.$error) return;

        // Check whether the select contains the value 4 and is empty.
        if (this.motiveAllowance.name.toLowerCase() === 'selecione') {
          this.invalidMotive = true;
          return;
        }
        if (this.motiveAllowance.name.toLowerCase() === 'outro' && !this.dataSend.reason) return;

        if (this.motiveAllowance.name.toLowerCase() !== 'outro') {
          this.dataSend.reason = this.motiveAllowance.name;
        }

        if(this.needException) {
          if(this.motiveExceptionAbono) {
            this.dataSend.sporadicCategoryId = this.motiveExceptionAbono.id
            this.validateExceptionAbono = false
          } else {
            return this.validateExceptionAbono = true
          }
        }

        this.dataSend.isAbonoAllDay = this.isAbonoAllDay;

        this.dataSend.userPointAdjustmentStatus = this.motiveAllowance.id;

        if (this.isAbonoAllDay === "true" || this.isAbonoAllDay === "false" && this.payMissingHours) {
          if (!this.objValue.userPointJson || this.isAbonoAllDay === "false")
            this.sendRequest();
          else {
            swal("Aviso", "\nNão é possivel realizar este abono pelo motivo:\n Existe ponto registrado para esse dia. Ao invés disso, solicite um ajuste.", "error");
          }
        } else {
          this.dataSend.listDates = [];
          let isValidForm = true;

          this.listHoursAbonoHalfDay.map((value, index) => {
            value.isValidEntry = this.checkHoursIsValid(value.hourEntry);
            value.isValidExit = this.checkHoursIsValid(value.hourExit);

            // Check all dates and hours is valid.
            if (!value.isValidExit || !value.isValidEntry || !value.entry || !value.exit)
              isValidForm = false;

            if (UTIL_SERVICE.checkDateStringIsInvalid(value.entry)) {
              isValidForm = false;
              value.isDateEntry = false;
            }

            if (UTIL_SERVICE.checkDateStringIsInvalid(value.exit)) {
              isValidForm = false;
              value.isDateExit = false;
            }

            if (isValidForm) {
              this.dataSend.listDates.push({
                date: moment(UTIL_SERVICE.convertStringToDateEua(value.entry)).format('YYYY-MM-DD') + "T" + value.hourEntry + ":00",
                userPointType: 1
              });
              this.dataSend.listDates.push({
                date: moment(UTIL_SERVICE.convertStringToDateEua(value.exit)).format('YYYY-MM-DD') + "T" + value.hourExit + ":00",
                userPointType: 2
              });
            }

            if (this.listHoursAbonoHalfDay.length === index + 1) {
              if (isValidForm) {
                this.sendRequest();
              }
            }
          });
        }
      },
      checkHoursIsValid(hour) {
        return /^([0-1]?[0-9]|2[0-3]):([0-5][0-9])(:[0-5][0-9])?$/.test(hour);
      },
      getListAdjustment() {
        REQUEST_SERVICE.get(GET_COMPANY_ADJ).then((response) => {
            UTIL_SERVICE.console("RESULT GET_COMPANY_ADJ:", response.data);

            this.listAdj = [];
            this.listAdjAbono = [];
            response.data.map(v => {
              if (v.type === 0) {
                this.listAdj.push(v);
              } else {
                this.listAdjAbono.push(v);
              }
            });
            this.listAdj.unshift({id: '', name: 'Selecione'});
            this.listAdjAbono.unshift({id: '', name: 'Selecione'});

          }).catch(reason => {
          try {
            UTIL_SERVICE.historyLog(false, window.location.pathname, 'getListAdjustment', {}, true, reason.response.data);
          } catch (e) {}

          // Show errors.
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
      },
      getListException() {
        REQUEST_SERVICE.get(GET_EXCEPTION).then((response) => {
          UTIL_SERVICE.console("RESULT GET_EXCEPTION:", response.data);

          this.listException = response.data;

        });
      },
    },
    beforeMount() {
      moment.locale('pt-br');

      let dataUserInfo = UTIL_SERVICE.getStorage('userInfo');

      try {
        if(dataUserInfo.company.sporadic) {
          this.needException = dataUserInfo.company.sporadic
        }
      } catch (e) {}

      this.getListAdjustment();
      this.makeSolicitation();
      this.getListException();
    },
    validations: {
      motiveAdjustment: {required},
      motiveAllowance: {required},
      dataSend: {},
      listHours: {
        required,
        minLength: minLength(2),
        $each: {
          entry: {
            required
          },
          hourEntry: {
            required
          },
          exit: {
            required
          },
          hourExit: {
            required
          }
        }
      },
      listHoursAbonoHalfDay: {
        required,
        minLength: minLength(1),
        $each: {
          entry: {
            required
          },
          hourEntry: {
            required
          },
          exit: {
            required
          },
          hourExit: {
            required
          }
        }
      }
    }
  }
</script>

<style lang="scss">

.checkbox {
  margin: 0 0 0 20px;

  input {
    cursor: pointer;
    left: 0;
    top: -2px;
  }

  label {
    &::after {
      padding-top: 1px !important;
      color: #2F23D6 !important;
    }

    &::before {
      outline: none !important;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/vue/views/restricted/requestAdjustment/requestAdjustment.vue